const data = [
	{
		id: 1,
		img: require("./images/convert.png"),
		display: "https://metric-and-imperial-unit-converter.vercel.app/",
		language: ["HTML CSS  JAVASCRIPT REACT "],
		descriptionOne: "A Simple Metric Converter",
		descriptionTwo:
			"An app that Helps convert from one unit to another with ease",
		// link: "https://quizzical-app-ten.vercel.app/",
	},
	{
		id: 2,
		img: require("./images/password.png"),
		display: "https://random-passowrd-generator.vercel.app/",
		language: ["HTML CSS  JAVASCRIPT REACT "],
		descriptionOne: "Complex Password Generator",
		descriptionTwo:
			"An app that generates Extremely secured password on any length",
		// link: "https://quizzical-app-ten.vercel.app/",
	},
	{
		id: 3,
		img: require("./images/shopping.png"),
		display: "https://shopping-list-app-seven.vercel.app/",
		language: ["HTML CSS  JAVASCRIPT FIREBASE "],
		descriptionOne: "Shopping List ",
		descriptionTwo:
			"A Tool that allows you to save a list of items, so that you can remember what to purchase",
		// link: "https://quizzical-app-ten.vercel.app/",
	},
	{
		id: 4,
		img: require("./images/tenzies.png"),
		display: "https://tenzies-game-iota-mocha.vercel.app",
		language: ["HTML CSS  JAVASCRIPT REACT "],
		descriptionOne: "Tenzies Game",
		descriptionTwo: "The common Tenzies game- Only more Interesting!",
		// link: "https://quizzical-app-ten.vercel.app/",
	},
	{
		id: 5,
		img: require("./images/champions.png"),
		display: "https://we-are-champions-seven.vercel.app",
		language: ["HTML CSS  JAVASCRIPT JSON FIREBASE "],
		descriptionOne: "We are champions",
		descriptionTwo:
			"An app that assists you in sending messages to a public platform where anyone can interact with your content by liking and sending a reply",
		// link: "https://quizzical-app-ten.vercel.app/",
	},
	{
		id: 6,
		img: require("./images/quiz.png"),
		display: "https://quizzical-app-ten.vercel.app",
		language: ["HTML CSS  JAVASCRIPT REACT "],
		descriptionOne: "Quizzical",
		descriptionTwo:
			"An app that Generates questions related to a specific subject and answers can be graded on submit",
		// link: "https://quizzical-app-ten.vercel.app/",
	},
	{
		id: 7,
		img: require("./images/decentralized_lottery.png"),
		display: "https://smart-contract-lottery-blue.vercel.app",
		language: ["NEXT.JS HARDHAT MORALIS WEB3UIKIT SOLIDITY"],
		descriptionOne: "Decentralized Lottery",
		descriptionTwo:
			"A decentralized application that functions as an automated lottery system, ensuring trustworthiness and transparency for its users",
	},
	{
		id: 8,
		img: require("./images/saver.png"),
		display: "https://safe-lock-interface.vercel.app/",
		language: [
			"NEXT.JS HARDHAT MORALIS WEB3UIKIT SOLIDITY WAGMI ETHER.JS VIEM WALLET-CONNECT",
		],
		descriptionOne: "Decentralized Savings Application",
		descriptionTwo:
			"A decentralized application named 'TokenLock' enables users to securely store their digital assets, including stablecoins and regular cryptocurrencies, using blockchain technology. It empowers users to retain their holdings for an indefinite period while ensuring advanced security measures are in place.",
	},
];

const skills = [
	{
		header: "Language",
		data: ["Javascript Typescript Node.js Solidity"],
	},
	{
		header: "Databases",
		data: ["Mongodb Firebase"],
	},
	{
		header: "FrameWorks",
		data: ["React Next.js  Express.js Mongoose Tailwind Hardhat Ether.js Foundry"],
	},
	{ header: "Other", data: ["HTML CSS SCSS GIT"] },
];

export default data;
export { skills };
